import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ProgressDescriptionDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center"
    },
    text: {
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: ProgressDescriptionDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
